// Pure derivation logic for Trusted Advisor's "Findings Over Time" chart — extracted from
// TrustedAdvisorDashboard.tsx so it can be unit tested independently of the component's
// rendering and API calls (same pattern as channelLandingOverlay.ts).

export interface FindingsOverTimeRecord {
  first_seen_at?: string | null;
  closed_at?: string | null;
}

export interface FindingsOverTimePoint {
  month: string;
  newFindings: number;
  remediated: number;
}

/**
 * "New findings" is grouped by first_seen_at's month; "remediated" is grouped independently
 * by closed_at's month — a record can contribute to either series, both, or neither, and the
 * two series are never assumed to share a timestamp.
 */
export function buildFindingsOverTime(records: FindingsOverTimeRecord[]): FindingsOverTimePoint[] {
  const newByMonth: Record<string, number> = {};
  const remediatedByMonth: Record<string, number> = {};

  records.forEach(r => {
    if (r.first_seen_at) {
      const d = new Date(r.first_seen_at);
      if (!Number.isNaN(d.getTime())) {
        const bucket = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        newByMonth[bucket] = (newByMonth[bucket] || 0) + 1;
      }
    }
    if (r.closed_at) {
      const d = new Date(r.closed_at);
      if (!Number.isNaN(d.getTime())) {
        const bucket = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        remediatedByMonth[bucket] = (remediatedByMonth[bucket] || 0) + 1;
      }
    }
  });

  const months = [...new Set([...Object.keys(newByMonth), ...Object.keys(remediatedByMonth)])].sort();
  return months.map(month => ({
    month,
    newFindings: newByMonth[month] || 0,
    remediated: remediatedByMonth[month] || 0,
  }));
}
